import { render, staticRenderFns } from "./EditChart.vue?vue&type=template&id=6c0c57fc&"
import script from "./EditChart.vue?vue&type=script&lang=js&"
export * from "./EditChart.vue?vue&type=script&lang=js&"
import style0 from "./EditChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports